// additionalActService.js

import api from './api';

const API_ROUTE = '/additionalacts';

export const additionalActService = {
  // READ
  async getAllByContractId(contractId) {
    // Assuming you have an endpoint to get all acts for a contract
    const response = await api.get(`${API_ROUTE}/contract/${contractId}`);
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`${API_ROUTE}/${id}`);
    return response.data;
  },

  // CREATE
  async create(additionalActData) {
    const response = await api.post(API_ROUTE, additionalActData);
    return response.data;
  },

  // BULK CREATE
  async createBulk(bulkData) {
    const response = await api.post(`${API_ROUTE}/bulk`, bulkData);
    return response.data;
  },

  // UPDATE
  async update(id, updateData) {
    const response = await api.put(`${API_ROUTE}/${id}`, updateData);
    return response.data;
  },

  // DELETE
  async delete(id) {
    await api.delete(`${API_ROUTE}/${id}`);
  },

  // ACTIONS

  // Send Additional Act
  async sendAdditionalAct(id, emails) {
    const response = await api.post(`${API_ROUTE}/${id}/send`, { emails });
    return response.data;
  },

  // Download Signed File
  async downloadSignedFile(id, path) {
    const response = await api.get(`${API_ROUTE}/${id}/download-signed-file`, {
      params: { path },
      responseType: 'blob'
    });
    return response.data;
  },

  // PDF Generation (Assuming you have this endpoint)
  async generatePdf(id) {
    const response = await api.post(`${API_ROUTE}/${id}/generate-pdf`);
    return response.data;
  },

  // Download PDF (Assuming you have this endpoint)
  async downloadPdf(id) {
    const response = await api.get(`${API_ROUTE}/${id}/download-pdf`, {
      responseType: 'blob'
    });
    // --- 1. Extract the Filename from Headers ---
    const contentDisposition = response.headers['content-disposition'];
    let filename = `contract_${id}.pdf`; // Fallback filename

    if (contentDisposition) {
      // This regex extracts the quoted filename from the Content-Disposition header
      const filenameMatch = contentDisposition.match(/filename\*?=['"]?([^"']+)['"]?(?:$|;)/i);
      if (filenameMatch && filenameMatch[1]) {
        // Decode the filename (important for non-ASCII characters) and clean up quotes
        filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
      }
    }

    // --- 2. Return the data and the filename ---
    return {
      blob: response.data,
      filename: filename,
    };
  },
};